import React from "react";
import "./ContactUsComp.css";
import Loader from "../Loader/Loader";
const ContactUsComp = () => {
  return (
    <>
    <Loader/>
      <div className="mainOurServices">
        <div className="ourServiceTxt">Contact Us Anytime, Anywhere.</div>
        {/* 
        <div className="middleLine"></div>
        <div className="ourServTxtPara">
          Explore The UK With Experienced Drivers.
        </div> */}
      </div>

      <div className="mainContainerContact">
        <div className="contactUsPgTxt">Feel Free To Reach Us</div>

        <div className="topCardContactUs">
          <div className="cardContactUS">
            <div className="cardTopTxtContact">Phone</div>

            <div className="lineContactCard"></div>
            <div className="numberCardTxtContact">+44 (0) 73 89779904</div>
          </div>
          <div className="cardContactUS">
            <div className="cardTopTxtContact">Email</div>

            <div className="lineContactCard"></div>
            <div className="numberCardTxtContact">info@wubu.co.uk</div>
          </div>
          <div className="cardContactUS">
            <div className="cardTopTxtContact">Address</div>

            <div className="lineContactCard"></div>
            <div className="numberCardTxtContact">
              BST 392 Third Avenue, Trafford Park, Manchester, M17 1JE
            </div>
          </div>
        </div>
      </div>

      <iframe
              width="100%"
              height="350"
              id="gmap_canvas"
            //   src="https://maps.google.com/maps?q=The%20Drop%20Off%20Delivery%20Company%201%20Tunisia%20St,%20Hawally,%20Kuwait&t=&z=13&ie=UTF8&iwloc=&output=embed"
              src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=BST%20392%20Third%20Avenue,%20Trafford%20Park,%20Manchester,%20M17%201JE+(My%20Business%20Name)&amp;t=p&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
              frameborder="0"
              scrolling="no"
              marginheight="0"
              marginwidth="0"
            ></iframe>
    </>
  );
};

export default ContactUsComp;
